import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotAlarmGroup, CreateSnapshotAlarmGroupDto } from 'types';

export const createSnapshotAlarmGroup = ({
  data,
}: {
  data: CreateSnapshotAlarmGroupDto;
}): Promise<SnapshotAlarmGroup> => {
  return axios.post('/api/snapshots/alarms/groups', data);
};

type UseCreateSnapshotAlarmGroupOptions = {
  alarmId: number;
  config?: MutationConfig<typeof createSnapshotAlarmGroup>;
};

export const useCreateSnapshotAlarmGroup = ({
  alarmId,
  config,
}: UseCreateSnapshotAlarmGroupOptions) => {
  return useMutation({
    onMutate: async (newSnapshotAlarmGroup) => {
      await queryClient.cancelQueries(['alarms', alarmId, 'groups']);

      const previousSnapshotAlarmGroups = queryClient.getQueryData<
        SnapshotAlarmGroup[]
      >(['alarms', alarmId, 'groups']);

      queryClient.setQueryData(
        ['alarms', alarmId, 'groups'],
        [...(previousSnapshotAlarmGroups || []), newSnapshotAlarmGroup.data]
      );

      return { previousSnapshotAlarmGroups };
    },
    onError: (_, __, context: any) => {
      if (context?.previousSnapshotAlarmGroups) {
        queryClient.setQueryData(
          ['alarms', alarmId, 'groups'],
          context.previousSnapshotAlarmGroups
        );
      }
    },
    onSuccess: (data: SnapshotAlarmGroup) => {
      queryClient.invalidateQueries(['alarms', alarmId, 'groups']);
    },
    ...config,
    mutationFn: createSnapshotAlarmGroup,
  });
};
